import CryptoJS from 'crypto-js';

  const SECRET_KEY = "W0rkf1ow@1absW3b";
  const salt = "w3bAppFus10n5@1t";

// export function generateUserKey(username) {
//   return CryptoJS.PBKDF2(username, SECRET_KEY, {
//     keySize: 256 / 32
//   }).toString();
// }

// export function generateStrongUniqueKey(length = 32) {
//   const array = new Uint8Array(length);
//   window.crypto.getRandomValues(array);
//   return Array.from(array, byte => ('0' + byte.toString(16)).slice(-2)).join('');
// }

// export function encryptPassword(password, username) {
//   // const salt = CryptoJS.lib.WordArray.random(128 / 8).toString();
//   const userKey = generateUserKey(username);
//   const saltedPassword = salt + password;
//   const encrypted = CryptoJS.AES.encrypt(saltedPassword, userKey).toString();
//   return { encrypted };
// }

// export function decryptPassword(encryptedPassword, username){
//   const userKey = generateUserKey(username);
//   const decrypted = CryptoJS.AES.decrypt(encryptedPassword, userKey).toString(CryptoJS.enc.Utf8);
//   const password = decrypted.slice(salt.length);
//   return password;
// }


export function encryptPassword(password) {
  const userKey = SECRET_KEY+salt;
  const encrypted = CryptoJS.AES.encrypt(password, userKey).toString();
  return { encrypted };
}

export function decryptPassword(encryptedPassword){
  const userKey = SECRET_KEY+salt;
  const decrypted = CryptoJS.AES.decrypt(encryptedPassword, userKey).toString(CryptoJS.enc.Utf8);
  const password=decrypted;
  return password;
}